import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";

const SLICE = "baselineAudits";

export const getAllActiveAuditsBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "findAllActiveAuditsBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const getAllActiveUploadsByAuditId = getFromServerTopic({
  topic: SLICE,
  action: "findAllActiveUploadsByAuditId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const addNewBaselineAudit = getFromServerTopic({
  topic: SLICE,
  action: "addNewBaselineAudit",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const updateBaselineAudit = getFromServerTopic({
  topic: SLICE,
  action: "updateBaselineAudit",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const deleteAuditEntry = getFromServerTopic({
  topic: SLICE,
  action: "deleteAuditEntry",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const deleteAuditUpload = getFromServerTopic({
  topic: SLICE,
  action: "deleteAuditUpload",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const uploadNewFileToAudit = getFromServerTopic({
  topic: SLICE,
  action: "uploadNewFileToAudit",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const getAuditFile = getFromServerTopic({
  topic: SLICE,
  action: "getAuditFile",
  payloadFn: async (payload) => {
    return payload;
  },
});
export const slice = createSlice({
  name: SLICE,
  initialState: {
    buildingAudits: {},
    admin: false,
  },
  reducers: {
    handleChangeAdmin: (state) => {
      state.admin = !state.admin;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveAuditsBySiteId.fulfilled, (state, action) => {
      if (action.payload) {
        state.buildingAudits[`${action.meta.arg.site_id}`] = [
          ...action.payload.response,
        ];
      }
    });
  },
});

export const { handleChangeAdmin } = slice.actions;

export default slice.reducer;
